var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 66 66",
    height: 512,
    viewBox: "0 0 66 66",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48.46 5.97v50.06h-36.42v3.98h40.4v-54.04z",
    fill: "#9ea3ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.33 2.04-10.22 10.22v43.82h40.4v-54.04z",
    fill: "#f6f0f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.39,
    cy: 37.41,
    fill: "#ff7146",
    r: 14.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.7 44.73c-4.03 4.03-10.59 4.03-14.62 0s-4.03-10.59 0-14.62 10.59-4.03 14.62 0c4.04 4.02 4.04 10.58 0 14.62z",
    fill: "#ffc040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.8 48.41-2.05-2.05c-.35.44-.72.87-1.13 1.28s-.84.78-1.28 1.13l2.05 2.05c-.23 1.04.05 2.16.85 2.97l9.23 9.23c1.25 1.25 3.28 1.25 4.53 0s1.25-3.28 0-4.53l-9.23-9.23c-.81-.8-1.93-1.08-2.97-.85z",
    fill: "#0e4b5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.28 12.21v-10.22l-10.22 10.22z",
    fill: "#9ea3ad"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2b2a3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.22 29.57c-2.09-2.09-4.88-3.25-7.85-3.25s-5.76 1.15-7.85 3.25-3.25 4.88-3.25 7.85 1.15 5.76 3.25 7.85c2.09 2.09 4.88 3.25 7.85 3.25s5.76-1.15 7.85-3.25c4.32-4.33 4.32-11.37 0-15.7zm-1.06 14.64c-1.81 1.81-4.22 2.81-6.79 2.81s-4.98-1-6.79-2.81-2.81-4.22-2.81-6.79 1-4.98 2.81-6.79 4.22-2.81 6.79-2.81 4.98 1 6.79 2.81c3.74 3.74 3.74 9.83 0 13.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.54 58-9.24-9.25c-.86-.86-2.05-1.26-3.25-1.13l-1.33-1.33c4.28-5.95 3.76-14.3-1.58-19.65-5.94-5.94-15.6-5.94-21.54 0s-5.94 15.6 0 21.54c2.97 2.97 6.87 4.45 10.77 4.45 3.12 0 6.24-.97 8.88-2.87l1.33 1.33c-.14 1.2.27 2.39 1.13 3.24l9.24 9.25c.77.77 1.78 1.16 2.8 1.16 1.01 0 2.03-.39 2.8-1.16.75-.75 1.16-1.74 1.16-2.8-.01-1.04-.43-2.04-1.17-2.78zm-35.89-10.87c-5.35-5.35-5.35-14.07 0-19.42 2.68-2.68 6.19-4.02 9.71-4.02s7.03 1.34 9.71 4.02c5.35 5.35 5.35 14.07 0 19.42s-14.06 5.35-19.42 0zm34.83 15.4c-.96.96-2.52.96-3.47 0l-9.24-9.24c-.59-.59-.84-1.45-.65-2.28.06-.25-.02-.51-.2-.69l-1.47-1.47c.02-.02.03-.04.04-.06.22-.2.45-.38.66-.6.21-.21.39-.43.59-.65.02-.02.05-.03.06-.05l1.47 1.47c.18.18.44.26.69.2.83-.19 1.68.06 2.28.65l9.24 9.25c.46.46.72 1.08.72 1.74 0 .65-.26 1.27-.72 1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.72 33.06c-.29-.29-.77-.29-1.06 0l-3.29 3.29-3.29-3.29c-.29-.29-.77-.29-1.06 0s-.29.77 0 1.06l3.29 3.3-3.29 3.29c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l3.29-3.29 3.29 3.29c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-3.29-3.29 3.29-3.3c.29-.29.29-.76 0-1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.92 7.2h18.95c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-18.95c-.41 0-.75.34-.75.75s.34.75.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.88 9.67h-18.97c-.41 0-.75.34-.75.75s.34.75.75.75h18.97c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.88 13.68h-9.96c-.41 0-.75.34-.75.75s.34.75.75.75h9.96c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.88 17.68h-9.96c-.41 0-.75.34-.75.75s.34.75.75.75h9.96c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.26 59.34h-32.47v-2.48h28.49c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-32.48v-42.38h9.48c.41 0 .75-.34.75-.75v-9.48h28.72v43.4c0 .41.34.75.75.75s.75-.34.75-.75v-39.42h2.48v43.03c0 .41.34.75.75.75s.75-.34.75-.75v-43.78c0-.41-.34-.75-.75-.75h-3.23v-3.23c0-.41-.34-.75-.75-.75h-30.21c-.2 0-.39.08-.53.22l-10.24 10.23c-.14.14-.22.33-.22.53v43.87c0 .41.34.75.75.75h3.23v3.23c0 .41.34.75.75.75h33.22c.41 0 .75-.34.75-.75s-.33-.74-.74-.74zm-35.4-47.86 7.67-7.67v7.67z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.e3d747ae8f3836e042085d334c3eae45.svg";
export { ForwardRef as ReactComponent };